import { render, staticRenderFns } from "./VDesignTaskSubstituting.vue?vue&type=template&id=5841c971&"
import script from "./VDesignTaskSubstituting.vue?vue&type=script&lang=ts&"
export * from "./VDesignTaskSubstituting.vue?vue&type=script&lang=ts&"
import style0 from "./VDesignTaskSubstituting.vue?vue&type=style&index=0&id=5841c971&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports